import { NotificationsContent } from '@/components/notifications/NotificationsContent';

export default function NotificationsPage() {
  return <NotificationsContent />;
}
